var WINDOW = {
  ms_Width: 0,
  ms_Height: 0,
  ms_Callbacks: {
    70: "WINDOW.toggleFullScreen()" // Toggle fullscreen
  },

  initialize: function initialize() {
    this.updateSize();

    // Create callbacks from keyboard
    $(document).keydown(function(inEvent) { WINDOW.callAction(inEvent.keyCode); }) ;
    $(window).resize(function(inEvent) {
      WINDOW.updateSize();
      WINDOW.resizeCallback(WINDOW.ms_Width, WINDOW.ms_Height);
    });
  },
  updateSize: function updateSize() {
    var UA =  navigator.userAgent.indexOf('iPhone') > 0 ||
              navigator.userAgent.indexOf('iPod') > 0 ||
              navigator.userAgent.indexOf('Android') > 0 ? 'SP' : 'PC';
    this.ms_Width = $(window).width();
    this.ms_Height = $(window).height() - 4;

    if (UA == 'SP') {
      this.ms_Height = $(window).height() + 70;
    }
  },
  callAction: function callAction(inId) {
    if(inId in this.ms_Callbacks) {
      eval(this.ms_Callbacks[inId]);
      return false ;
    }
  },
  toggleFullScreen: function toggleFullScreen() {
    if(!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
      if(document.documentElement.requestFullscreen)
        document.documentElement.requestFullscreen();
      else if(document.documentElement.mozRequestFullScreen)
        document.documentElement.mozRequestFullScreen();
      else if(document.documentElement.webkitRequestFullscreen)
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    }
    else  {
      if(document.cancelFullScreen)
        document.cancelFullScreen();
      else if(document.mozCancelFullScreen)
        document.mozCancelFullScreen();
      else if (document.webkitCancelFullScreen)
        document.webkitCancelFullScreen();
    }
  },
  resizeCallback: function resizeCallback(inWidth, inHeight) {}
};

module.exports = WINDOW;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/water/window.js
// module id = 21
// module chunks = 1